import { AutocompleteInput, useGetOne } from 'react-admin';
import { useState, useMemo, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useInfiniteAutocomplete } from '../../../hooks/useInfiniteAutocomplete';

export const TestAutocomplete = (props: any) => {
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const source = props.source || 'testId';

    const { watch } = useFormContext();
    const currentValue = watch(source);

    const { data: initialTest } = useGetOne(
        'tests',
        { id: currentValue },
        { enabled: !!currentValue && !selectedItem },
    );

    const {
        choices: fetchedChoices,
        isLoading,
        setSearchText,
        handleScroll,
    } = useInfiniteAutocomplete('tests', {
        baseFilter: { deleted: false, ...(props.type && { type: props.type }) },
        searchField: 'name',
    });
    useEffect(() => {
        if (initialTest && !selectedItem) {
            setSelectedItem(initialTest);
        }
    }, [initialTest, selectedItem]);

    const choices = useMemo(() => {
        const dataArray = fetchedChoices || [];
        if (selectedItem && !dataArray.find((item: any) => item.id === selectedItem.id)) {
            return [selectedItem, ...dataArray];
        }
        return dataArray;
    }, [fetchedChoices, selectedItem]);


    return (
        <AutocompleteInput
            {...props}
            source={source}
            fullWidth
            label={props.label || 'Test'}
            choices={choices}
            optionText="name"
            optionValue="id"
            loading={isLoading}
            setFilter={value => setSearchText(value)}
            onChange={value => {
                const selected = choices.find((item: any) => item.id === value);
                if (selected) {
                    setSelectedItem(selected);
                }
                if (props.onChange) {
                    props.onChange(value);
                }
            }}
            debounce={500}
            shouldRenderSuggestions={(val: string) => {
                return val.trim().length >= 0;
            }}
                ListboxProps={{ onScroll: handleScroll }}
        />
    );
};
